/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import {
  Grid,
  Typography,
  RACTable,
  RACTableRow,
  RACTableCell,
} from '@rentacenter/racstrap';
import { ReactComponent as PayCash } from './../../assets/images/paycash.svg';
import { ReactComponent as Oxxo } from './../../assets/images/Oxxo_Logo 1.svg';
import { barcodeStyles } from '../../stylesJS/barcodeStyles';
import { agreementContext } from '../context/PaymentInformationContext';
import { BarcodeGeneration } from './BarcodeGeneration';
import { useTranslation } from "react-i18next";
import { AgreementDetails } from '../interface/paymentInfoInterface';
import { ReactComponent as AlertIcon } from './../../assets/apiErrorIcon.svg';

export const TenderBarcodeGrid = () => {
  const [hoveredRow, setHoveredRow] = useState<string | null>(null);
  const classes = barcodeStyles();
  const agreementInfo = useContext(agreementContext);
  const storeNumber = window.sessionStorage.getItem('storeNumber') || '';
  const { t } = useTranslation("PayCash");
  useEffect(() => {
    debugger
    console.log('barcode classes ',classes);
  }, []);
  

  const agreementDetails: AgreementDetails[] = Array.isArray(
    agreementInfo.agreementDetails
  )
    ? agreementInfo.agreementDetails
    : [];

  const [generatedBarcodes, setGeneratedBarcodes] = useState<
    AgreementDetails[]
  >([]);
  const [showBarcode, setShowBarCode] = useState<boolean>(false);

  const handleViewClick = (
    agreement: AgreementDetails,
    type: 'oxxo' | 'payCash'
  ) => {
    const newBarcode = { ...agreement, [type]: true };
    setShowBarCode(true);
    setGeneratedBarcodes([newBarcode]);
  };

  const isViewDisabled = (el: AgreementDetails) =>
    el.isLDWActionPerformed === 'Y' ||
    el.isLDWActionPerformed === 'N' ||
    el.isEditScheduleEdited ||
    el.agreementStatus === 'PRELIM' ||
    el.agreementStatus === 'PRELIMINV' ||
    el.agreementStatus === 'PEND';

  const renderViewLink = (el: AgreementDetails, type: 'oxxo' | 'payCash') => {
    const disabled = isViewDisabled(el);
    return (
      <Typography>
        <a
          className={`${classes.viewLink} ${
            disabled ? classes.disabledLink : ''
          }`}
          onClick={!disabled ? () => handleViewClick(el, type) : undefined}
          style={{ pointerEvents: disabled ? 'none' : 'auto' }}
        >
          {t("view")}
        </a>
      </Typography>
    );
  };

  // RACTable Head
  const agreementTableHead = () => (
    <>
      <RACTableCell className={classes.agreementCell}>{t("Agreement #")}</RACTableCell>
      <RACTableCell className={classes.tableCell}>
        <span
          style={{
            verticalAlign: 'middle',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <Oxxo style={{ height: 18, width: 50 }} /> {t("Oxxo Pay")}
        </span>
      </RACTableCell>
      <RACTableCell className={classes.tableCell}>
        <span
          style={{
            verticalAlign: 'middle',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <PayCash style={{ height: 18, width: 50 }} /> {t("Pay Cash")}
        </span>
      </RACTableCell>
    </>
  );

  // RACTable Body
  const agreementTableBody = () => (
    <>
      {agreementDetails
        .filter(
          (el) =>
            String(el.storeNumber) === String(storeNumber) &&
            String(el.storeNumber).length > 0
        )
        .map((el) => {
          const showAlert =
            el.isLDWActionPerformed === 'Y' ||
            el.isLDWActionPerformed === 'N' ||
            el.isEditScheduleEdited;
          return (
            <RACTableRow key={el.agreementNumber} backgroundColor="#fff">
              {/* Agreement # cell with optional tooltip */}
              <RACTableCell className={classes.agreementCell}>
                <Grid
                  className={classes.displayflex}
                  style={{ alignItems: 'center' }}
                >
                  <Typography
                    className={classes.ml15px}
                    style={{ fontWeight: 500 }}
                  >
                    {el.agreementNumber}
                  </Typography>
                  {showAlert && (
                    <div
                      className={classes.tooltipContainer}
                      onMouseEnter={() => setHoveredRow(el.agreementNumber)}
                      onMouseLeave={() => setHoveredRow(null)}
                    >
                      <AlertIcon
                        style={{
                          marginLeft: 8,
                          verticalAlign: 'middle',
                          height: '15px',
                          marginBottom: '4px',
                        }}
                      />
                      <span
                        className={`${classes.tooltipText} ${
                          hoveredRow === el.agreementNumber
                            ? classes.tooltipVisible
                            : ''
                        }`}
                      >
                        <Typography style={{ fontSize: 13 }}>
                          {t("Some details have been changed. Kindly proceed with a payment to generate a barcode.")}
                        </Typography>
                      </span>
                    </div>
                  )}
                </Grid>
              </RACTableCell>
              {/* Oxxo Pay view link */}
              <RACTableCell className={classes.tableCell}>
                {renderViewLink(el, 'oxxo')}
              </RACTableCell>
              {/* Pay Cash view link */}
              <RACTableCell className={classes.tableCell}>
                {renderViewLink(el, 'payCash')}
              </RACTableCell>
            </RACTableRow>
          );
        })}
    </>
  );

  return (
    <>
      <Grid item md={12} className={classes.textCenter}>
        <RACTable
          className={`${classes.racGrid} ${classes.mb32}`}
          renderTableHead={agreementTableHead}
          renderTableContent={agreementTableBody}
        />
      </Grid>
      {showBarcode && (
        <BarcodeGeneration
          barcodeAgreements={generatedBarcodes}
          viewClick={generatedBarcodes.length > 0}
        />
      )}
    </>
  );
};
